// extracted by mini-css-extract-plugin
export default {"firstLine":"Title_firstLine__wfgPx","letter":"Title_letter__3NOE5"};